import { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import EnterpriseInputField, {
  EnterpriseInputProps,
} from "./EnterpriseInputField";

type Props = Omit<EnterpriseInputProps, "type" | "trailingIcon">;

export default function EnterprisePasswordInput(props: Props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <EnterpriseInputField
      {...props}
      type={showPassword ? "text" : "password"}
      trailingIcon={
        <button
          type="button"
          disabled={props.disabled}
          aria-label={showPassword ? "Hide password" : "Show password"}
          aria-pressed={showPassword}
          onClick={() => setShowPassword((previous) => !previous)}
          className="flex h-4 w-4 shrink-0 items-center justify-center rounded p-0 text-bash focus-visible:outline focus-visible:outline-2 focus-visible:outline-bblue"
        >
          {showPassword ? <FiEye size={12} /> : <FiEyeOff size={12} />}
        </button>
      }
    />
  );
}
